// eslint-disable-next-line
var OrdersAlgoConfig = {
    lines: {
        a: 11, b: 7, c: 11, d: 7, e: 10, f: 7, g: 11, h: 7, i: 11, o: 10, p: 10, q: 10, r: 6
    },
    // https://docs.google.com/spreadsheets/d/1rT4MdK0eggOG4mkrLHG2ObZIvVaNmnuTer6OYiebxIc/edit?gid=1340815426#gid=1340815426
    generators: {
        AB: {
            stages: [{}, {}, {},
                { drop: ["a"] },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 110 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 120 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 140 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 140 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 140 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 140 },
                { drop: ["a", "b"], weights: [0.9, 0.1], power: 140 }
            ],

            spawn: 80,
            cooldown: 3
        },
        CD: {
            stages: [{}, {}, {},
                { drop: ["c"] },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 140 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 170 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 200 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 200 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 210 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 210 },
                { drop: ["c", "d"], weights: [0.9, 0.1], power: 210 }
            ],
            spawn: 80,
            cooldown: 3
        },
        Z: {
            stages: [{}, {}, {}, {},
                { drop: ["e"], destroyAfterDrops: true, spawn: 12 }
            ],
            spawn: 12,
            cooldown: 3
        },
        E: {
            stages: [{}, {}, {}, {}, 
                { drop: ["Z"], power: 100 },
                { drop: ["Z"], power: 110 },
                { drop: ["Z"], power: 120 },
                { drop: ["Z"], power: 140 },
                { drop: ["Z"], power: 150 },
                { drop: ["Z"], power: 150 },
                { drop: ["Z"], power: 150 }
            ],
            algorithm: {
                customPrice: 2.33,
                overrideDrop: ["e"]
            },
            spawn: 26,
            cooldown: 3
        },
        F: {
            stages: [{}, {}, {}, {}, {},
                { drop: ["f"], spawn: 6, cooldown: 60 },
                {
                    drop: ["f"], spawn: 8, cooldown: 80, power: 120 
                },
                {
                    drop: ["f"], spawn: 11, cooldown: 110, power: 130
                },
                {
                    drop: ["f"], spawn: 15, cooldown: 150, power: 150
                },
                {
                    drop: ["f"], spawn: 20, cooldown: 200, power: 180
                }

            ],
            algorithm: {
                customPrice: 3
            },
            autoMine: true,
            energy: 0
        },
        GH: {
            stages: [{}, {}, {}, {},
                { drop: ["g"] },
                { drop: ["g", "h"], weights: [0.9, 0.1] },
                { drop: ["g", "h"], weights: [0.9, 0.1], power: 115 },
                { drop: ["g", "h"], weights: [0.9, 0.1], power: 160 },
                { drop: ["g", "h"], weights: [0.9, 0.1], power: 165 },
                { drop: ["g", "h"], weights: [0.9, 0.1], power: 165 },
                { drop: ["g", "h"], weights: [0.9, 0.1], power: 165 }
            ],
            spawn: 72,
            cooldown: 3
        },
        I: {
            stages: [{}, {}, {}, {},
                { drop: ["i"] },
                { drop: ["i"], power: 110 },
                { drop: ["i"], power: 120 },
                { drop: ["i"], power: 140 },
                { drop: ["i"], power: 160 },
                { drop: ["i"], power: 160 },
                { drop: ["i"], power: 160 }
            ],
            spawn: 90,
            cooldown: 3
        },
        O: {
            stages: [{}, {}, {},
                { drop: ["o"] },
                { drop: ["o"], power: 110 },
                { drop: ["o"], power: 120 },
                { drop: ["o"], power: 130 }
            ],
            spawn: 6,
            cooldown: 60
        },
        P: {
            stages: [{}, {}, {},
                { drop: ["p"] },
                { drop: ["p"], power: 110 },
                { drop: ["p"], power: 120 },
                { drop: ["p"], power: 130 }
            ],
            spawn: 6,
            cooldown: 60
        },
        QR: {
            stages: [{}, {}, {},
                { drop: ["q", "r"], power: 100, weights: [0.9, 0.1] },
                { drop: ["q", "r"], power: 110, weights: [0.9, 0.1] },
                { drop: ["q", "r"], power: 120, weights: [0.9, 0.1] },
                { drop: ["q", "r"], power: 130, weights: [0.9, 0.1] }
            ],
            spawn: 6,
            cooldown: 60
        },
        S: {
            stages: [{}, {}, {},
                { drop: ["s"], destroyAfterDrops: true, spawn: 6 }
            ],
            spawn: 6,
            cooldown: 3
        },
        SS: {
            stages: [
                { drop: ["S"] }
            ],
            algorithm: {
                customPrice: 2.33,
                overrideDrop: ["s"]
            },
            spawn: 4,
            cooldown: 150
        },
        T: {
            stages: [
                { drop: ["t"] }
            ],
            spawn: 4,
            cooldown: 180
        },
        U: {
            stages: [
                { drop: ["u"] }
            ],
            spawn: 4,
            cooldown: 180
        }
    }
};

if (typeof cc === "undefined") {
    module.exports = OrdersAlgoConfig;
}
